import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

import 'src/configs/i18n'
import { Provider } from 'react-redux'
import { store } from './stores'
import LoaderManager from './pages/managers/LoaderManager'
import SnackbarManager from './pages/managers/SnackbarManager'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <Provider store={store}>
        <React.StrictMode>
            <LoaderManager />
            <App />
            <SnackbarManager />
        </React.StrictMode>
    </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
